import { createPortal } from "react-dom";

interface Props {
  hideModal?: () => void;
  className?: string;
  children?: JSX.Element;
}

export const CenteredModal = (props: Props) => {
  const modal = (
    <div
      className="tw-fixed tw-left-0 tw-top-0 tw-z-[9999] tw-flex tw-h-[100%] tw-w-[100%] tw-items-center tw-justify-center tw-bg-gray-2 tw-bg-opacity-75"
      style={{ transform: "translateZ(0)" }} // No tailwind equivalent (makes sure that the z index takes effect)
      onClick={() => {
        if (props.hideModal) {
          props.hideModal();
        }
      }}
    >
      <div
        className={`tw-relative tw-flex tw-rounded-md tw-bg-white ${props.className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {props.children}
      </div>
    </div>
  );

  // Use createPortal to ensure that the modal is always above all other components (regardless of stacking context)
  return createPortal(modal, document.body);
};
